import { useCallback } from 'react';

// eslint-disable-next-line import/no-unresolved
import { DragEndEvent } from '@dnd-kit/core/dist/types';
import { arrayMove } from '@dnd-kit/sortable';
import { useDispatch } from 'react-redux';

import { updateTripEventsPositionsAction } from 'store/itinerariesItem';

import { TDayTripEvent } from '../types';

export function useEventList({ events }: { events: TDayTripEvent[] }) {
  const dispatch = useDispatch();

  const handleDragEnd = useCallback(
    (evt: DragEndEvent) => {
      const { active, over } = evt;

      if (active.id !== over?.id) {
        const oldIndex = events.map((e) => e.id).indexOf(active.id as number);
        const newIndex = events.map((e) => e.id).indexOf(over?.id as number);

        const sortedTripEvents = arrayMove(events, oldIndex, newIndex);

        dispatch(updateTripEventsPositionsAction({ sortedTripEvents }));
      }
    },
    [dispatch, events],
  );

  return {
    handleDragEnd,
  };
}
